module.exports = __webpack_public_path__ + "border.png?f8a0d25c7e28e88294b72605e11bd309";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/border.png
// module id = 314
// module chunks = 0